import React, { useRef, useState, useEffect } from "react";
import { format, isValid, parse } from "date-fns";
import Swal from "sweetalert2";
import {
  
  Input,
  Box,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Textarea,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerFooter,
  DrawerBody,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import axios from "axios";
import { BsUpload } from "react-icons/bs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import GalleryUpdate from "./GalleryUpdate";
import AdminLogin from "../AdminNav/Login";

import { Flex, Image, SimpleGrid, Text } from "@chakra-ui/react";
import { PageHeader, Panel } from "../../components/ui";
import { API_URL } from "../../Apis/config";

function GalleryForm() {
  const [blogSlides, setBlogSlides] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [render, setRender] = useState(false);
  const [isopen, setIsopen] = useState(false);

  const initialValues = {
    imageSrc: "",
    date: "03/07/2023",
    title: "",
    text: "",
  };
  useEffect(() => {
    axios
      .get(`${API_URL}/gallery`)
      .then((res) => {
        // Format the date for each slide before updating the state
        // console.log(res.data);
        const formattedSlides = res.data.map((slide) => ({
          ...slide,
        }));
        setBlogSlides(formattedSlides);
        setIsDataFetched(true);
      })
      .catch((err) => console.log(err));
  }, [render]);
  const inputFileRef = useRef(null);
  const [imagePreview, setImagePreview] = useState("");
  const [showModal, setShowModal] = useState(false);

  
  const handleUploadButtonClick = () => {
    inputFileRef.current.click();
  };

  const handleImageChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("imageSrc", file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImagePreview("");
    }
  };

  const handleSubmit = async (values, actions) => {
    try {
      // Start the submit animation
      actions.setSubmitting(true);

      // Simulate a delay to show the animation
      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Set up Cloudinary configuration
      let imageUrl = "";
      try {
        const formData = new FormData();
        formData.append("file", values.imageSrc);

        formData.append("upload_preset", "tekxwxfz"); // Replace with your Cloudinary unsigned upload preset

        const response = await axios.post(
          `https://api.cloudinary.com/v1_1/dzidj8k7j/auto/upload`,
          formData
        );
        imageUrl = response.data.secure_url;
      } catch (error) {
        console.error(error);
        toast.error("Error submitting the form.");
        return;
      }
      const formattedDate = format(new Date(values.date), "dd/MM/yyyy");

      // Update the values object with the formatted date and the image URL
      const updatedValues = {
        ...values,
        date: formattedDate,
        imageSrc: imageUrl,
      };

      // console.log(updatedValues);
      // Handle form submission here with the updated values
      const response = await axios.post(
        `${API_URL}/gallery`,
        updatedValues
      );
      // console.log(response.data);

      // Display success toast
      toast.success("Form submitted successfully!");

      actions.resetForm(); // Reset the form fields
      setImagePreview(""); // Reset the image preview
      actions.setSubmitting(false); // Stop the submit animation
      setShowModal(false);
      setRender(!render);
      setIsDataFetched(false);
    } catch (error) {
      console.error(error);

      // Display error toast
      toast.error("Error submitting the form.");

      actions.setSubmitting(false); // Stop the submit animation on error
    }
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };
  function deleteItem(itemId) {
    // Confirm deletion and send delete request to the API
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ff1403",
      cancelButtonColor: "#6fe273",
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${API_URL}/gallery/${itemId}`, {
          method: "DELETE",
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            // console.log(`Item with ID ${itemId} deleted successfully.`);
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Deleting successfully",
              timer: 1500,
              showConfirmButton: false,
            });
            setRender(!render);
          })
          .catch((error) => {
            console.error(
              `Error while deleting Item with ID ${itemId}:`,
              error
            );

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Deleting Failed",
            });
          });
      }
    });
  }
  const modalUpdate = () => {
    setIsopen(false);
  };
  const updateFunc = (item) => {
    axios
      .patch(
        `${API_URL}/gallery/${selectedData._id}`,
        item
      )
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Updating successfully",
          timer: 1500,
          showConfirmButton: false,
        });
        modalUpdate();
        setRender(!render);
      })
      .catch((err) =>
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Deleting Failed",
        })
      );
  };
  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }
  return (
    <>
      

      <ToastContainer />
      <PageHeader title="Gallery" subtitle="Photos shown on the website">
        <Button onClick={openModal}>Add item</Button>
      </PageHeader>
      <Drawer size="md" isOpen={showModal} onClose={closeModal}>
            <DrawerOverlay />
            <DrawerContent>
              <DrawerHeader>Add Gallery Image</DrawerHeader>
              <DrawerCloseButton />
              <DrawerBody>
                <Formik
                  initialValues={initialValues}
                  onSubmit={handleSubmit}
                  // validate={validateForm}
                >
                  {(props) => (
                    <Form className="Form">
                      {/* Image upload */}
                      <Field name="imageSrc">
                        {({ field, form }) => (
                          <FormControl
                            isInvalid={form.errors.image && form.touched.image}
                          >
                            <FormLabel>Image</FormLabel>
                            <Button
                              onClick={handleUploadButtonClick}
                              leftIcon={<BsUpload />}
                              variant="outline"
                            >
                              Upload Image
                            </Button>
                            <Box display="none">
                              <input
                                type="file"
                                accept="image/*"
                                ref={inputFileRef}
                                onChange={(event) =>
                                  handleImageChange(event, props.setFieldValue)
                                }
                              />
                            </Box>
                            {imagePreview && (
                              <Box mt={4}>
                                <img
                                  src={imagePreview}
                                  alt="Image Preview"
                                  style={{
                                    maxWidth: "200px",
                                    borderRadius: ".5rem",
                                  }}
                                />
                              </Box>
                            )}
                            <FormErrorMessage>
                              {form.errors.image}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>

                      {/* Date input */}
                      <Field name="date">
                        {({ field, form }) => (
                          <FormControl
                            isInvalid={form.errors.date && form.touched.date}
                            mt={4}
                          >
                            <FormLabel>Date</FormLabel>
                            <Input {...field} type="date" placeholder="Date" />
                            <FormErrorMessage>
                              {form.errors.date}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>

                      {/* Title input */}
                      <Field name="title">
                        {({ field, form }) => (
                          <FormControl
                            isInvalid={form.errors.title && form.touched.title}
                            mt={4}
                          >
                            <FormLabel>Title</FormLabel>
                            <Input {...field} type="text" placeholder="Title" />
                            <FormErrorMessage>
                              {form.errors.title}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>

                      {/* Text input */}
                      <Field name="text">
                        {({ field, form }) => (
                          <FormControl
                            isInvalid={form.errors.text && form.touched.text}
                            mt={4}
                          >
                            <FormLabel>Text</FormLabel>
                            <Textarea {...field} placeholder="Text" />
                            <FormErrorMessage>
                              {form.errors.text}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>

                      {/* Submit button */}
                      <Button
                        w="100%"
                        mt={4}
                        isLoading={props.isSubmitting}
                        type="submit"
                      >
                        Submit
                      </Button>
                    </Form>
                  )}
                </Formik>
              </DrawerBody>
              <DrawerFooter>
                <Button variant="ghost" mr={3} onClick={closeModal}>
                  Close
                </Button>
              </DrawerFooter>
            </DrawerContent>
          </Drawer>
      <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={4}>
        {blogSlides &&
          blogSlides.map((slide, index) => (
            <Panel key={index} overflow="hidden">
              <Image src={slide.imageSrc} alt={slide.title} w="100%" h="220px" objectFit="cover" />
              <Box p={4}>
                <Text fontSize="sm" color="stone.500">
                  {isValid(parse(slide.date, "dd/MM/yyyy", new Date()))
                    ? format(parse(slide.date, "dd/MM/yyyy", new Date()), "d MMMM yyyy")
                    : "Date needs fixing"}
                </Text>
                <Text fontWeight={600}>{slide.title}</Text>
                <Text fontSize="sm" noOfLines={3}>{slide.text}</Text>
                <Flex justify="space-between" mt={3}>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      setIsopen(true);
                      setSelectedData(slide);
                    }}
                  >
                    Update
                  </Button>
                  <Button variant="danger" size="sm" onClick={() => deleteItem(slide._id)}>
                    Delete
                  </Button>
                </Flex>
              </Box>
            </Panel>
          ))}
      </SimpleGrid>
      {isopen && (
        <GalleryUpdate
          slide={selectedData}
          onUpdate={updateFunc}
          check={true}
          modalCheck={modalUpdate}
        />
      )}
    </>
  );
}

export default GalleryForm;
